module.exports = __webpack_public_path__ + "static/media/fly0236.f855279b.webp";